import useTooltip from 'js/hooks/use-tooltip';

import Link from 'components/link/Link';
import Tooltip from 'components/tooltip/Tooltip';
import EventData from 'components/event-page/EventData';

import { IDatesMoreLink } from 'source/NFR.types';

interface IDatesMoreLinkProps extends IDatesMoreLink {
  isOpen?: boolean;
}

const DatesMoreLink: React.FC<IDatesMoreLinkProps> = ({ link, tooltip, isOpen }) => {
  const { ref, handleMouseEnter, handleMouseLeave, showTabTooltip, showTooltip } = useTooltip(isOpen);

  return (
    <li
      className="dates-more-link"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={ref as React.RefObject<HTMLLIElement>}
    >
      <Link className="dates-more-link--link" {...link} theme="actionLink" />
      {tooltip?.eventData && (showTabTooltip || showTooltip) && (
        <Tooltip useTabStyle={showTabTooltip}>
          <EventData {...tooltip.eventData} enableTabbing />
        </Tooltip>
      )}
    </li>
  );
};

DatesMoreLink.displayName = 'DatesMoreLink';

export default DatesMoreLink;
